/** ----------------------------------------
    Images
 ---------------------------------------- */

export class Slider {

    /** ----------------------------------------
        Scroll
     ---------------------------------------- */

    _scroll() {
        const instagram = document.querySelector('#js-instagram');
        const wrapper = instagram.querySelector('#js-wrapper');

        let value = 0;

        window.addEventListener('scroll', e => {
            if(this._inView(instagram)) {
                const bounding = instagram.getBoundingClientRect();
                value = Math.abs((bounding.top - window.innerHeight) * 0.5);
            }
        });

        const animate = () => {
            wrapper.style.left = `${ -Math.abs(value) }px`;
            window.requestAnimationFrame(animate);
        };

        window.requestAnimationFrame(animate);
    }

    /** ----------------------------------------
        View
     ---------------------------------------- */

    _inView(el) {
        const bounding = el.getBoundingClientRect();
        return bounding.top - window.innerHeight < 0 && bounding.bottom > 0;
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    /**
     * This function is called within the
     * constructor and will initiate once the
     * class is loaded.
     */

    init() {
        const instagram = document.querySelector('#js-instagram');
        if(!instagram) return;

        this._scroll();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/cases/anp/Slider.js